import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-width": "2"
    }, [
      _createElementVNode("rect", {
        width: "8",
        height: "14.22",
        x: "13.999",
        y: "6.281",
        rx: "2"
      }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M20 3H6a2 2 0 0 0-2 2v10.97h7M11 15.97H4a2 2 0 0 0-2 2v.531a2 2 0 0 0 2 2h7"
      })
    ], -1)
  ])))
}
export default { render: render }